var $5c9b9cd2e34e437c$exports = {};
$5c9b9cd2e34e437c$exports = {
    "pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`
};


export {$5c9b9cd2e34e437c$exports as default};
//# sourceMappingURL=el-GR.mjs.map
